import { IApplicationState } from '../../types/redux';

export const selectGeocodeCoordinates = (state: IApplicationState): number[] | null =>
  state.geocode.geocodeItems[0]?.coordinates ?? null;
// [82.892079, 54.988639];
